<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Daftar Akun</h1>
            <div class="section-header-breadcumb button">
                <a href="javascript:" @click.prevent="goTo('/finance/transfer-balance')" class="btn btn-icon icon-left btn-info mr-2"><i class="fa fa-arrows-h"></i> Transfer Balance</a>
                <a href="javascript:" @click.prevent="goTo('/finance/new-account')" class="btn btn-icon icon-left btn-primary"><i class="far fa-edit"></i> Buat Akun Baru</a>
            </div>
          </div>
        <div class="section-body">
           <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Daftar Akun</h4>
                            <div class="card-header-form">
                                <div class="input-group">
                                    <input type="text" v-model="filter" @keyup.enter="setFilter()" class="form-control" placeholder="Search Nama Akun, Kategori Akun , Role">
                                    <div class="input-group-btn">
                                        <button @click="setFilter()" class="btn btn-primary"><i class="fas fa-search"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="table-responsive">
                            <table class="table table-striped table-hover">
                                <tr>
                                    <th>#</th>
                                    <th></th>
                                    <th>Kode Akun</th>
                                    <th>Nama Akun</th>
                                    <th>Kategori Akun</th>
                                    <th>Saldo</th>
                                </tr>
                                <tbody>
                                    <tr style="cursor:pointer;" v-for="list in akunList" v-bind:key="list.main.id_coa" @click="goDetail(list.main.id_coa)">
                                        <td>{{ list.no }}</td>
                                        <td></td>
                                        <td>{{ list.main.kode_akun }}</td>
                                        <td>{{ list.main.nama_akun }}</td>
                                        <td>{{ list.main.nama_kategori }} </td>
                                        <td v-html="currencyFormat(list.main.saldo)"></td>
                                    </tr>
                                </tbody>

                            </table>
                            </div>
                        </div>
                        <div class="card-footer text-right">
                            <nav class="d-inline-block">
                            <ul class="pagination mb-0">
                                <li class="page-item" :class="{ disabled : firstDisabled }">
                                    <a class="page-link" v-if="firstDisabled == true" tabindex="-1"><i class="fas fa-chevron-left"></i></a>
                                    <a class="page-link" v-else @click="tableTo(page-1)" tabindex="-1"><i class="fas fa-chevron-left"></i></a>
                                </li>
                                <li v-for="pages in pagination" v-bind:key="pages" class="page-item" :class="{ active: pages == page}">
                                    <span class="page-link" @click="tableTo(pages)">{{ pages }}</span>
                                </li>
                                <li class="page-item" :class="{ disabled : lastDisabled }">
                                    <a class="page-link" v-if="lastDisabled == true"><i class="fas fa-chevron-right"></i></a>
                                    <a class="page-link" v-else @click="tableTo(page+1)"><i class="fas fa-chevron-right"></i></a>
                                </li>
                            </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            akunList : [],
            perPage: 100,
            page: 1,
            search: '',
            maxPagination: 5,
            first: 1,
            last: '',
            totalRow: '',
            pagination: [],
            filter : '',
            firstDisabled : true,
            lastDisabled : true,
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            this.$root.is_loading = !this.$root.is_loading;
            this.$http.get("Finance/getAkunList?perPage="+this.perPage+"&page="+this.page+"&search="+this.filter).then(result => {
			    if(result.data.code == '00') {
                    alert('failed get akun')
                }
                else {
                    this.akunList = result.data.detail.data;
                    this.totalRow = result.data.detail.totalRow;
                    this.last = Math.ceil(this.totalRow / this.perPage)
                    this.pagination = this.getPaging();
                    this.$nextTick(function(){
                        this.navDisabled();
                    })

                }
                this.$root.is_loading = !this.$root.is_loading;
			}, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            });
        },
        goTo: function(paths) {
            this.$router.push({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        getPaging: function() {
            var i;
            var paging = []
            if(this.page > this.first+2){
                this.first = this.page-3
            }else if(this.page == this.first && this.first != 1){
                this.first = this.page-3
                if(this.first < 1){
                    this.first = 1
                }
            }
            for(i = this.first;i < 6+this.first && i <= this.last; i++){
                paging.push(i)
            }
            return paging;
        },
        tableTo: function(page){
            this.page = page
            this.init();
        },
        goDetail: function(id_akun){
            this.$router.push({ path : '/finance/akun-detail/'+id_akun })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        setFilter: function(){
            this.page = 1;
            this.init();
        },
        navDisabled : function() {
            if(this.page == this.first){
                this.firstDisabled = true
                if(this.page < this.last) {
                    this.lastDisabled = false
                }
                return
            }
            if(this.page == this.last) {
                this.lastDisabled = true
                if(this.page > this.first) {
                    this.firstDisabled = false
                }
                return
            }
            if(this.page > this.first && this.page < this.last) {
                this.lastDisabled = false
                this.firstDisabled = false
            }

        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/daftar/DaftarAkun.vue